import { v4 } from "uuid";

import { IgButton } from "@intelligems/ig-theme";
import { EmbeddedPreviewError } from "@src/features/experienceBuilder/pageState/EmbeddedPreviewError";
import { useDispatch } from "@src/store";
import { ExperienceBuilderAction } from "@src/store/slices/experienceBuilder";

/**
 * Shown when the FE exhausted retries trying to capture HTML from the preview
 * iframe and had no cached snapshot to fall back on. Reload bumps `cacheKey`
 * so the iframe `src` changes — the iframe reloads, the plugin re-initializes,
 * and the next AI turn can capture fresh HTML. No close affordance: the only
 * path forward is the reload.
 */
export const PageHtmlUnavailableError = () => {
  const dispatch = useDispatch();

  const onReload = () => {
    dispatch(ExperienceBuilderAction.setPageHtmlUnavailable(false));
    dispatch(ExperienceBuilderAction.setCacheKey(v4()));
  };

  return (
    <EmbeddedPreviewError
      title="Preview not ready"
      description="Reload it and try again."
      buttons={
        <IgButton
          variant="contained"
          color="warning"
          onClick={onReload}
          sx={{ flex: 1 }}
        >
          Reload preview
        </IgButton>
      }
    />
  );
};
